/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const StationsFiltersTypeEnum = {
    STATION_TYPE: "STATION_TYPE"
} as const;

export type StationsFiltersTypeEnumKey = (typeof StationsFiltersTypeEnum)[keyof typeof StationsFiltersTypeEnum];

export const StationsFiltersValueEnum = {
    STANDALONE: "STANDALONE",
    HEADER: "HEADER",
    REPEATER: "REPEATER",
    AFFILIATE: "AFFILIATE"
} as const;

export type StationsFiltersValueEnumKey = (typeof StationsFiltersValueEnum)[keyof typeof StationsFiltersValueEnum];

export const StationsFiltersTypeEnum2 = {
    STATION_GROUP: "STATION_GROUP"
} as const;

export type StationsFiltersTypeEnum2Key = (typeof StationsFiltersTypeEnum2)[keyof typeof StationsFiltersTypeEnum2];

export const StationsFiltersTypeEnum3 = {
    STATION_INDIVIDUAL: "STATION_INDIVIDUAL"
} as const;

export type StationsFiltersTypeEnum3Key = (typeof StationsFiltersTypeEnum3)[keyof typeof StationsFiltersTypeEnum3];

/**
 * StreamQualityReportRequest
*/
export type WebAppStreamQualityReportBodyDto = {
    /**
     * @description Array of station selection filters.\n\nEach item is an object `{ type, value }` that selects a set of stations. Supported `type` values:\n- `STATION_TYPE` — all stations of that type (`STANDALONE`, `HEADER`, `REPEATER`, or `AFFILIATE`).\n- `STATION_GROUP` — all stations belonging to the given stations-group id.\n- `STATION_INDIVIDUAL` — the single station with the given station id or slug.\n\nMultiple filters are combined with OR: a station is included if it matches any filter.\nDuplicate stations across filters are de-duplicated. Disabled stations are always excluded.\n\nAn empty array (`[]`) means “no filter”: all enabled stations in scope.
     * @type array
    */
    stationsFilters: ({
        /**
         * @type string
        */
        type: StationsFiltersTypeEnumKey;
        /**
         * @type string
        */
        value: StationsFiltersValueEnumKey;
    } | {
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum2Key;
        /**
         * @type string, uuid
        */
        value: string;
    } | {
        /**
         * @type string
        */
        type: StationsFiltersTypeEnum3Key;
        /**
         * @minLength 1
         * @type string
        */
        value: string;
    })[];
    /**
     * @type string, date-time
    */
    from: string;
    /**
     * @type string, date-time
    */
    to: string;
};